<div
    [id]="form.displayId()"
    class="indent"
    [style.--indent-height]="height()"
    [style.--indent-height-tablet]="tabletHeight()"
    [style.--indent-height-mobile]="mobileHeight()"
></div>
